import * as Sentry from '@sentry/vue'

type SentryUser = Parameters<typeof Sentry.setUser>[0]
type LogAttributes = Record<string, unknown>

export function useSentry() {
  const captureException = (
    error: unknown,
    context?: Parameters<typeof Sentry.captureException>[1],
  ) => {
    Sentry.captureException(error, context)
  }

  const captureMessage = (message: string, level: Sentry.SeverityLevel = 'error') => {
    Sentry.captureMessage(message, level)
  }

  const setUser = (user: SentryUser) => {
    Sentry.setUser(user)
  }

  const setTag = (key: string, value: string) => {
    Sentry.setTag(key, value)
  }

  const addBreadcrumb = (breadcrumb: Sentry.Breadcrumb) => {
    Sentry.addBreadcrumb(breadcrumb)
  }

  const log = (message: string, attributes?: LogAttributes) => {
    Sentry.logger.info(message, attributes)
  }

  const warn = (message: string, attributes?: LogAttributes) => {
    console.warn(message, attributes)
    Sentry.logger.warn(message, attributes)
  }

  const error = (message: string, attributes?: LogAttributes) => {
    console.error(message, attributes)
    Sentry.logger.error(message, attributes)
  }

  return {
    captureException,
    captureMessage,
    setUser,
    setTag,
    addBreadcrumb,
    log,
    warn,
    error,
  }
}
